import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  ThreeDHolistic,
  ThreeDTransparent,
  ThreeDTimely,
  ThreeDQuality,
  ThreeDCuttingEdge,
  ThreeDFlexibleModels,
} from "../../../app-constants-updated";

function Websecurityefficient() {
  return (
    <section className="websecurity_efficient threed-partner p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={9}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>
              Why TekRevol is Your Ideal <span>3D Game</span> Development
              Partner
            </h2>
          </Col>
        </Row>
        <Row className="mt-3 mt-md-4">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <Row>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
                <div
                  className="web-security-box"
                  style={{ background: "#F6F6F6" }}
                >
                  <div className="web-security-icon">{ThreeDHolistic}</div>
                  <div className="web-security_content">
                    <h5 style={{ color: "#314252" }}>
                      Holistic Project Management
                    </h5>
                    <p style={{ color: "#898989" }}>
                      Introducing a client-oriented approach guarantees thorough
                      consideration of your expectations at every stage of the
                      work.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
                <div
                  className="web-security-box"
                  style={{ background: "#F6F6F6" }}
                >
                  <div className="web-security-icon">{ThreeDTransparent}</div>
                  <div className="web-security_content">
                    <h5 style={{ color: "#314252" }}>
                      Transparent Development Process
                    </h5>
                    <p style={{ color: "#898989" }}>
                      To further ensure customer courtesy, we keep several lines
                      of communication open with timely updates on each phase of
                      your game development.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
                <div
                  className="web-security-box"
                  style={{ background: "#F6F6F6" }}
                >
                  <div className="web-security-icon">{ThreeDTimely}</div>
                  <div className="web-security_content">
                    <h5 style={{ color: "#314252" }}>Timely Delivery</h5>
                    <p style={{ color: "#898989" }}>
                      An adaptive process and a strong team of more than 400+
                      employees ensure timely project completion with maximum
                      quality.
                    </p>
                  </div>
                </div>
              </Col>
              <Col
                xs={12}
                md={6}
                lg={6}
                xl={4}
                xxl={4}
                className="mb-xl-0 mb-4"
              >
                <div
                  className="web-security-box"
                  style={{ background: "#F6F6F6" }}
                >
                  <div className="web-security-icon">{ThreeDQuality}</div>
                  <div className="web-security_content">
                    <h5 style={{ color: "#314252" }}>
                      Rigorous Quality Assurance
                    </h5>
                    <p style={{ color: "#898989" }}>
                      QA is an important aspect of our development cycle. We
                      provide manual and automated tests to ensure flawless
                      results compliant with modern industry standards.
                    </p>
                  </div>
                </div>
              </Col>
              <Col
                xs={12}
                md={6}
                lg={6}
                xl={4}
                xxl={4}
                className="mb-md-0 mb-4"
              >
                <div
                  className="web-security-box"
                  style={{ background: "#F6F6F6" }}
                >
                  <div className="web-security-icon">{ThreeDCuttingEdge}</div>
                  <div className="web-security_content">
                    <h5 style={{ color: "#314252" }}>
                      Cutting-Edge Technology Integration
                    </h5>
                    <p style={{ color: "#898989" }}>
                      Our developers are always up to date with the gaming
                      industry trends and get acquainted with the new beneficial
                      tools and techniques.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div
                  className="web-security-box"
                  style={{ background: "#F6F6F6" }}
                >
                  <div className="web-security-icon">
                    {ThreeDFlexibleModels}
                  </div>
                  <div className="web-security_content">
                    <h5 style={{ color: "#314252" }}>
                      Flexible Engagement Models
                    </h5>
                    <p style={{ color: "#898989" }}>
                      As for collaboration, we provide flexible settings to meet
                      your needs and decision-making procedures, starting with
                      dedicated teams and augmented staffing supply.
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Websecurityefficient;
